module.exports = __webpack_public_path__ + "assets/img/setimg.094594f0.png";